import React from 'react';
import { trustedByLogos } from '../data/mock';

const TrustedBySection = () => {
  // Only show companies with logos
  const companiesWithLogos = trustedByLogos.filter(company => company.logo);
  
  // Duplicate logos for seamless infinite scroll
  const duplicatedLogos = [...companiesWithLogos, ...companiesWithLogos];

  return (
    <section className="trusted-section section-padding-small overflow-hidden">
      <div className="container">
        <div className="text-center mb-12">
          <p 
            className="body-small"
            style={{ 
              textTransform: 'uppercase', 
              letterSpacing: '0.2em',
              color: 'var(--text-light)',
              fontWeight: 500
            }}
          >
            Trusted by Industry Leaders
          </p>
        </div>
      </div>
      
      {/* Sliding Logos Container */}
      <div className="logo-slider-container">
        <div className="logo-slider">
          {duplicatedLogos.map((company, index) => (
            <div key={index} className="logo-slide-item">
              <img 
                src={company.logo} 
                alt={`${company.name} logo`}
                className="logo-slide-img"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBySection;
